// Captures the browser's PWA install prompt so a normal button click (e.g.
// "My Profile") can trigger it later. This only works where the browser
// supports `beforeinstallprompt` (Chrome/Edge/Android) — Safari and iOS
// never fire it, so canPromptInstall() just stays false there and callers
// should fall back to normal navigation.
let deferredEvent = null;
let installed = false;

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredEvent = e;
  });
  window.addEventListener("appinstalled", () => {
    installed = true;
    deferredEvent = null;
  });
  if (window.matchMedia?.("(display-mode: standalone)").matches) {
    installed = true;
  }

  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  }
}

export function canPromptInstall() {
  return !!deferredEvent && !installed;
}

export async function promptInstall() {
  if (!deferredEvent) return { outcome: "unavailable" };
  const event = deferredEvent;
  deferredEvent = null; // the captured event can only be used once
  event.prompt();
  try {
    return await event.userChoice;
  } catch {
    return { outcome: "unavailable" };
  }
}
